import { render } from "./PanelRight.vue?vue&type=template&id=10b4b0ea&scoped=true"
const script = {}

import "./PanelRight.vue?vue&type=style&index=0&id=10b4b0ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b4b0ea"]])

export default __exports__